export default __webpack_public_path__ + "static/media/mercy-icon.1002e6a1.webp";